export default function LoadingSpinner({ console }: { console?: boolean }) {
    return (
        <div className="flex h-full items-center justify-center">
            <div
                className={`h-10 w-10 animate-spin rounded-full border-4 border-t-transparent ${console ? "border-console" : "border-primary"}`}
            ></div>
        </div>
    );
}
